import { Action } from 'redux';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import { IFeedback } from '../types/feedback';

export const FEEDBACK_FETCH_REQUEST = 'FEEDBACK_FETCH_REQUEST';
export const FEEDBACK_FETCH_SUCCESS = 'FEEDBACK_FETCH_SUCCESS';
export const FEEDBACK_FETCH_ERROR = 'FEEDBACK_FETCH_ERROR';

export interface IFeedbackFetchRequestAction extends Action {
  type: typeof FEEDBACK_FETCH_REQUEST;
  payload: IPaginationParams;
}

export interface IFeedbackFetchSuccessAction extends Action {
  type: typeof FEEDBACK_FETCH_SUCCESS;
  payload: { feedback: IFeedback[]; meta: IPaginationMetaResponse };
}

export interface IFeedbackFetchErrorAction extends Action {
  type: typeof FEEDBACK_FETCH_ERROR;
  message: string;
}

export type IFeedbackFetchAction = IFeedbackFetchSuccessAction | IFeedbackFetchErrorAction;

export function fetchFeedbackRequest(params?: IPaginationParams): IFeedbackFetchRequestAction {
  return {
    type: FEEDBACK_FETCH_REQUEST,
    payload: {
      ...params,
    },
  };
}

export function fetchFeedbackSuccess(
  feedback: IFeedback[],
  meta: IPaginationMetaResponse
): IFeedbackFetchSuccessAction {
  return {
    type: FEEDBACK_FETCH_SUCCESS,
    payload: {
      feedback,
      meta,
    },
  };
}

export function fetchFeedbackError(message: string): IFeedbackFetchErrorAction {
  return {
    type: FEEDBACK_FETCH_ERROR,
    message,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/feedback.ts